import ContactQRcode from '@rendora/common/features/contact/ui/Qrcode.vue';
import { useEmptyModal } from '~/hooks/useModal/modals/empty';

export const showDynamicContact = async (code: number, title: string, description: string) => {
  useEmptyModal({
    maskClosable: true,
    width: 268,
    content: (
      <div class={'flex flex-col items-center justify-center gap-[12px] p-[24px]'}>
        <div class={'text-[16px] font-medium text-[var(--text-1)]'}>{title}</div>
        <ContactQRcode
          code={code}
          size="220px"
          class={' bg-[var(--back-2)]'}
          source_from="youyan"
        />
        <div class={'text-[14px] text-[var(--text-1-80)]'}>{description}</div>
      </div>
    ),
  });
};
